import { render, staticRenderFns } from "./sumPeopleFlow.vue?vue&type=template&id=1558c97e"
import script from "./sumPeopleFlow.vue?vue&type=script&lang=js"
export * from "./sumPeopleFlow.vue?vue&type=script&lang=js"
import style0 from "./sumPeopleFlow.vue?vue&type=style&index=0&id=1558c97e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports